module.exports = __webpack_public_path__ + "img/GENERIC_FTP-CAMERA.bd611cf1.png";